
import React from "react";

interface FreeformIconProps {
  color?: string;
  size?: number;
  className?: string;
  strokeWidth?: number;
}

const FreeformIcon: React.FC<FreeformIconProps> = ({ color, size = 20, className = "", strokeWidth = 2 }) => {
  // Use currentColor if no color is provided, allowing CSS classes to control the color
  const strokeColor = color || "currentColor";
  
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ minWidth: `${size}px`, minHeight: `${size}px` }} // Force exact dimensions
    >
      {/* Free-form layout with scattered elements */}
      <rect
        x="3"
        y="4"
        width="6"
        height="4"
        rx="1"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        fill="none"
      />
      
      <rect
        x="12"
        y="2"
        width="8"
        height="5"
        rx="1"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        fill="none"
      />
      
      <rect
        x="2"
        y="11"
        width="7"
        height="6"
        rx="1"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        fill="none"
      />
      
      <rect
        x="13"
        y="10"
        width="5"
        height="4"
        rx="1"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        fill="none"
      />
      
      <rect
        x="15"
        y="17"
        width="6"
        height="4"
        rx="1"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        fill="none"
      />
    </svg>
  );
};

export default FreeformIcon;
